import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function ClosedDealTotalProceedsField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='total-proceeds-helper-text'
          label='Total Proceeds'
          id='total_proceeds'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />

        {error ? (
          <FormHelperText id='total-proceeds-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='total-proceeds-helper-text'>
            Enter the total proceeds realized.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
